<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Manufacturer" class="w-5/12">
      <input [ngModel]="poHeader.manufacturer.name" disabled pInputText />
    </uni-field>
    <uni-field label="Account - (for account-owned inventory)" class="w-1/2">
      <input [ngModel]="account?.accountName" disabled pInputText />
    </uni-field>

    <button (click)="lookupAccount()" pButton type="button" class="p-button-raised">Select Account</button>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <button (click)="lookupProductType()" pButton type="button" class="p-button-raised">Select Product Type</button>
    <label>... or ...</label>
    <button (click)="lookupMptcs()" pButton type="button" class="p-button-raised">Select Manufacturer Product Type Config</button>
    <div class="mt-2"><small *ngIf="productType == null" class="error-hint">A Product Type must be specified</small></div>
  </div>

  <div class="flex flex-row mt-3" style="height: calc(100% - 120px)">
    <app-ag-grid [gridOptions]="podGridOptions" [rowData]="pods"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2 mt-2">
    <button (click)="save()" pButton type="button" class="p-button-raised">Save</button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
